
const templateVariables = {
  name: 'libraryMainsite-1.0.3',
  locate: 'vn',
  folderUse: [
    'main',
  ],
  generateFile: ['frame1'],
  H5: false,
  scaleWidthPC: 0,
  scaleWidthMB: 0,
  scssVariable: {
    minWidthPC: '768px',
    maxWidthMB: '0',
  }
};

module.exports = templateVariables;